"use client";

import Link from "next/link";
import { useTranslations, useLocale } from "next-intl";
import { cn } from "~/lib/utils";

type FormPrivacyNoticeProps = {
  variant:
    | "signup"
    | "contact"
    | "waitlist"
    | "invitation"
    | "guestSubscription";
  className?: string;
};

export function FormPrivacyNotice({
  variant,
  className,
}: FormPrivacyNoticeProps) {
  const t = useTranslations("privacy.notice");
  const locale = useLocale();

  return (
    <p
      className={cn(
        "text-muted-foreground mt-4 text-center text-xs text-balance",
        className,
      )}
    >
      {t(variant)}
      <br />
      {t.rich("moreInfo", {
        link: (chunks) => (
          <Link
            href={`/${locale}/confidentialite`}
            className="hover:text-foreground underline underline-offset-2 transition-colors"
          >
            {chunks}
          </Link>
        ),
      })}
      {variant !== "guestSubscription" && (
        <>
          <br />
          {t("contactRights", { email: "bonjour@notreimmeuble.fr" })}
        </>
      )}
    </p>
  );
}
